<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
               <el-col :span="24">
          <el-form-item label="添加等级" prop="danger_lavel">
            <el-radio-group v-model="form_data.danger_lavel">
              <el-radio :label="parseInt(index)" v-for="(item,index) in LEVEL" :key="index" >{{item}} </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
           <el-col :span="24">
          <el-form-item label="隐患类型" prop="danger_classify">
            <el-select v-model="form_data.danger_classify" placeholder="请选择隐患类型" :disabled="classify.length==0 ||isInfo">
              <el-option v-for="item in classify" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
           <el-col :span="24">
          <el-form-item label="期望整改天数" prop="expect_day">
            <el-input type="text" v-model="form_data.expect_day" placeholder="请输入期望整改天数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="danger">
            <el-input type="textarea" v-model="form_data.danger" autocomplete="off" :rows="4" maxlength="250" placeholder="请输入检查内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标准" prop="rectification">
            <el-input type="textarea" v-model="form_data.rectification" autocomplete="off" :rows="4" maxlength="250" placeholder="请输入检查标准"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import { LEVEL } from './rental';
export default {
  name: 'l-rental-info-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    specs_id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      LEVEL:LEVEL,
           classify: [],
      //表单数据
      form_data: {
        rectification: '',
        danger: '',
        danger_lavel: 1,
        expect_day: 15,
        danger_classify: 1
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    //获取数据
    getData() {
      // if (this.hasId) {
      this.loading = true;
      this.$_invoke(`checkSpecs_proposalGetEditData`, { id: this.$props.id }).then((ret) => {
        if(this.hasId){
        this.form_data = ret.data;
        }
        this.classify = ret.classify;
      }).finally(() => {
        this.loading = false;
      });
      // }
    },
    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.submitting = true;
      if (!this.hasId) {//添加
        this.$_invoke('checkSpecs_proposalGetSave', {
          specs_id: this.$props.specs_id,
          ...this.form_data
        }).then(() => {
          this.$_msg.success('将喝口水都发多少添加成功');
          this.$emit('on-success');
        }).finally(() => {
          this.submitting = false;
        })
      } else {//修改
        this.$_invoke(`checkSpecs_proposalUpdate`, {
          id: this.$props.id,
          ...this.form_data
        }).then(() => {
          this.$_msg.success('修改成功');
          this.$emit('on-success');
        }).finally(() => {
          this.submitting = false;
        })
      }

    },
    
  },
}
</script>